export enum StowageRuleViolationStatus {
    NotApplicable,
    New,
    Accepted,
}
